import { useContext } from 'react';
import { DeviceContext } from '../contexts/device_context';

const useDevice = () => {
    return useContext(DeviceContext);
};

export default useDevice;
